import { render, staticRenderFns } from "./CourseLessonPlan.vue?vue&type=template&id=8ea79fba&scoped=true&"
import script from "./CourseLessonPlan.vue?vue&type=script&lang=js&"
export * from "./CourseLessonPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea79fba",
  null
  
)

export default component.exports